module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ado-page"
  }, [_c('div', {
    staticClass: "pg-title-row"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "ado-ghost-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openAdminTools
    }
  }, [_c('svg', {
    staticClass: "ado-btn-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 15.5A3.5 3.5 0 1 0 12 8a3.5 3.5 0 0 0 0 7.5Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.6V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1-1.6 1.7 1.7 0 0 0-1.9.3l-.1.1A2 2 0 1 1 4.2 17l.1-.1a1.7 1.7 0 0 0 .3-1.9 1.7 1.7 0 0 0-1.6-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.6-1 1.7 1.7 0 0 0-.3-1.9L4.2 7A2 2 0 1 1 7 4.2l.1.1a1.7 1.7 0 0 0 1.9.3h.1A1.7 1.7 0 0 0 10 3V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.6 1.7 1.7 0 0 0 1.9-.3l.1-.1A2 2 0 1 1 19.8 7l-.1.1a1.7 1.7 0 0 0-.3 1.9v.1A1.7 1.7 0 0 0 21 10h.1a2 2 0 1 1 0 4H21a1.7 1.7 0 0 0-1.6 1Z"
    }
  })]), _vm._v("\n      Admin Tools\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "ado-command-strip"
  }, [_c('div', {
    staticClass: "ado-command-item ado-command-item-active"
  }, [_c('span', {
    staticClass: "ado-command-kicker"
  }, [_vm._v("Active race")]), _vm._v(" "), _c('strong', {
    staticClass: "ado-command-value"
  }, [_vm._v(_vm._s(_vm.selectedRace ? _vm.selectedRace.id + ' - ' + _vm.selectedRace.name : 'No race selected'))])]), _vm._v(" "), _c('div', {
    staticClass: "ado-command-item"
  }, [_c('span', {
    staticClass: "ado-command-kicker"
  }, [_vm._v("Loaded results")]), _vm._v(" "), _c('strong', {
    staticClass: "ado-command-value"
  }, [_vm._v(_vm._s(_vm.raceResults.length))])]), _vm._v(" "), _c('div', {
    staticClass: "ado-command-item"
  }, [_c('span', {
    staticClass: "ado-command-kicker"
  }, [_vm._v("Runner context")]), _vm._v(" "), _c('strong', {
    staticClass: "ado-command-value"
  }, [_vm._v(_vm._s(_vm.selectedRunner ? _vm.selectedRunner.id + ' - ' + _vm.selectedRunner.firstName : 'Search by runner id'))])])]), _vm._v(" "), _c('div', {
    staticClass: "ado-workbench"
  }, [_c('section', {
    staticClass: "ado-card ado-race-card"
  }, [_c('div', {
    staticClass: "ado-card-header ado-card-header-compact"
  }, [_c('div', {
    staticClass: "ado-header-left"
  }, [_c('span', {
    staticClass: "ado-icon-pill"
  }, [_c('svg', {
    staticClass: "ado-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 2v4"
    }
  }), _c('path', {
    attrs: {
      "d": "M16 2v4"
    }
  }), _c('path', {
    attrs: {
      "d": "M3 10h18"
    }
  }), _c('path', {
    attrs: {
      "d": "M5 4h14a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"
    }
  })])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "ado-filter-panel"
  }, [_c('label', {
    staticClass: "ado-field"
  }, [_c('span', {
    staticClass: "ado-label"
  }, [_vm._v("Search")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.raceSearch),
      expression: "raceSearch"
    }],
    staticClass: "ado-input",
    attrs: {
      "type": "text",
      "placeholder": "race id or description"
    },
    domProps: {
      "value": (_vm.raceSearch)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchRaces.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.raceSearch = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ado-date-range-control"
  }, [_c('span', {
    staticClass: "ado-label"
  }, [_vm._v("Date range")]), _vm._v(" "), _c('button', {
    staticClass: "ado-range-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleDatePicker
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.dateRangeLabel))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.dateFilter.rangeStart === _vm.dateFilter.rangeEnd ? 'Single day' : 'Range'))])]), _vm._v(" "), _c('svg', {
    staticClass: "ado-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 2v4"
    }
  }), _c('path', {
    attrs: {
      "d": "M16 2v4"
    }
  }), _c('path', {
    attrs: {
      "d": "M3 10h18"
    }
  }), _c('path', {
    attrs: {
      "d": "M5 4h14a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"
    }
  })])]), _vm._v(" "), (_vm.datePickerOpen) ? _c('div', {
    staticClass: "ado-calendar-popover"
  }, [_c('div', {
    staticClass: "ado-calendar-presets"
  }, [_c('button', {
    staticClass: "ado-date-chip",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setDatePreset('today')
      }
    }
  }, [_vm._v("Today")]), _vm._v(" "), _c('button', {
    staticClass: "ado-date-chip",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setDatePreset('yesterday')
      }
    }
  }, [_vm._v("Yesterday")]), _vm._v(" "), _c('button', {
    staticClass: "ado-date-chip",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setDatePreset('last7')
      }
    }
  }, [_vm._v("Last 7 days")])]), _vm._v(" "), _c('div', {
    staticClass: "ado-calendar-head"
  }, [_c('button', {
    staticClass: "ado-icon-btn",
    attrs: {
      "type": "button",
      "title": "Previous month"
    },
    on: {
      "click": function($event) {
        return _vm.shiftCalendarMonth(-1)
      }
    }
  }, [_c('svg', {
    staticClass: "ado-btn-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m15 18-6-6 6-6"
    }
  })])]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.calendarMonthLabel))]), _vm._v(" "), _c('button', {
    staticClass: "ado-icon-btn",
    attrs: {
      "type": "button",
      "title": "Next month"
    },
    on: {
      "click": function($event) {
        return _vm.shiftCalendarMonth(1)
      }
    }
  }, [_c('svg', {
    staticClass: "ado-btn-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m9 18 6-6-6-6"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ado-calendar-weekdays"
  }, _vm._l((_vm.calendarWeekdays), function(weekday) {
    return _c('span', {
      key: weekday
    }, [_vm._v(_vm._s(weekday))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "ado-calendar-grid"
  }, _vm._l((_vm.calendarDays), function(day) {
    return _c('button', {
      key: day.key,
      staticClass: "ado-calendar-day",
      class: {
        'ado-calendar-day-muted': !day.inMonth,
        'ado-calendar-day-selected': _vm.isCalendarBoundary(day.value),
        'ado-calendar-day-range': _vm.isCalendarInRange(day.value),
        'ado-calendar-day-today': day.value === _vm.todayInput,
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectCalendarDay(day.value)
        }
      }
    }, [_vm._v("\n                " + _vm._s(day.label) + "\n              ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "ado-calendar-footer"
  }, [_c('span', [_vm._v(_vm._s(_vm.pendingDateRangeLabel))]), _vm._v(" "), _c('button', {
    staticClass: "ado-primary-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.applyDateRange
    }
  }, [_c('svg', {
    staticClass: "ado-btn-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 21l-4.3-4.3"
    }
  }), _c('circle', {
    attrs: {
      "cx": "11",
      "cy": "11",
      "r": "8"
    }
  })]), _vm._v("\n                Apply & Load\n              ")])])]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "ado-ghost-btn ado-fluid-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchRaces
    }
  }, [_vm._v("Search Races")])]), _vm._v(" "), (_vm.raceLoading) ? _c('div', {
    staticClass: "ado-skeleton-list"
  }, _vm._l((4), function(idx) {
    return _c('div', {
      key: idx,
      staticClass: "ado-skeleton-row"
    }, [_c('span', {
      staticClass: "sk-shimmer ado-sk-title"
    }), _vm._v(" "), _c('span', {
      staticClass: "sk-shimmer ado-sk-line"
    }), _vm._v(" "), _c('span', {
      staticClass: "sk-shimmer ado-sk-pill"
    })])
  }), 0) : _c('div', {
    staticClass: "ado-race-list"
  }, [_vm._l((_vm.races), function(race) {
    return _c('button', {
      key: race.id,
      staticClass: "ado-race-option",
      class: {
        'ado-race-option-selected': _vm.selectedRace && _vm.selectedRace.id === race.id
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectRace(race)
        }
      }
    }, [_c('span', {
      staticClass: "ado-race-main"
    }, [_c('strong', {
      staticClass: "ado-race-title"
    }, [_vm._v(_vm._s(race.id) + " - " + _vm._s(race.name))]), _vm._v(" "), _c('span', {
      staticClass: "ado-race-meta"
    }, [_vm._v(_vm._s(race.trainer && race.trainer.firstName ? race.trainer.firstName : 'Trainer not set'))])]), _vm._v(" "), _c('span', {
      staticClass: "ado-race-stats"
    }, [_c('span', {
      staticClass: "ado-stat-pill"
    }, [_vm._v(_vm._s(race.duration || '-'))]), _vm._v(" "), _c('span', {
      staticClass: "ado-stat-pill"
    }, [_vm._v(_vm._s(race.totalAmountRunners || 0) + " runners")])]), _vm._v(" "), _c('span', {
      staticClass: "ado-race-foot"
    }, [_c('span', [_vm._v(_vm._s(_vm.formatDate(race.rawStartDate || race.rawDate) || 'No date'))]), _vm._v(" "), (race.liveClassRecordedUrl) ? _c('a', {
      staticClass: "ado-mini-link",
      attrs: {
        "href": race.liveClassRecordedUrl,
        "target": "_blank",
        "rel": "noopener"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_vm._v("Recording")]) : _vm._e()])])
  }), _vm._v(" "), (_vm.races.length === 0) ? _c('div', {
    staticClass: "ado-empty-state"
  }, [_vm._v("No races loaded for this filter.")]) : _vm._e()], 2)]), _vm._v(" "), _c('section', {
    staticClass: "ado-card ado-results-card"
  }, [_c('div', {
    staticClass: "ado-card-header ado-card-header-spread"
  }, [_c('div', {
    staticClass: "ado-header-left"
  }, [_c('span', {
    staticClass: "ado-icon-pill"
  }, [_c('svg', {
    staticClass: "ado-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 21h8"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 17v4"
    }
  }), _c('path', {
    attrs: {
      "d": "M7 4h10v5a5 5 0 0 1-10 0V4Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M5 6H3a4 4 0 0 0 4 4"
    }
  }), _c('path', {
    attrs: {
      "d": "M19 6h2a4 4 0 0 1-4 4"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "ado-card-title"
  }, [_vm._v("Race Results")]), _vm._v(" "), _c('p', {
    staticClass: "ado-card-sub"
  }, [_vm._v(_vm._s(_vm.selectedRace ? _vm.selectedRace.id + ' - ' + _vm.selectedRace.name : 'Select a race to load result rows.'))])])]), _vm._v(" "), (_vm.selectedRace) ? _c('div', {
    staticClass: "ado-actions ado-results-actions"
  }, [_c('button', {
    staticClass: "ado-ghost-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openBulkMedalDialog()
      }
    }
  }, [_vm._v("Bulk Medal")]), _vm._v(" "), _c('button', {
    staticClass: "ado-primary-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openResultDialog()
      }
    }
  }, [_c('svg', {
    staticClass: "ado-btn-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 5v14"
    }
  }), _c('path', {
    attrs: {
      "d": "M5 12h14"
    }
  })]), _vm._v("\n            Add Result\n          ")])]) : _vm._e()]), _vm._v(" "), (_vm.selectedRace) ? _c('div', {
    staticClass: "ado-selected-race-panel"
  }, [_c('div', {
    staticClass: "ado-race-summary-item"
  }, [_c('span', {
    staticClass: "ado-command-kicker"
  }, [_vm._v("Duration")]), _vm._v(" "), _c('strong', {
    staticClass: "ado-command-value"
  }, [_vm._v(_vm._s(_vm.selectedRace.duration || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "ado-race-summary-item"
  }, [_c('span', {
    staticClass: "ado-command-kicker"
  }, [_vm._v("Runners")]), _vm._v(" "), _c('strong', {
    staticClass: "ado-command-value"
  }, [_vm._v(_vm._s(_vm.selectedRace.totalAmountRunners || 0))])]), _vm._v(" "), _c('div', {
    staticClass: "ado-race-summary-item"
  }, [_c('span', {
    staticClass: "ado-command-kicker"
  }, [_vm._v("Start")]), _vm._v(" "), _c('strong', {
    staticClass: "ado-command-value"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.selectedRace.rawStartDate || _vm.selectedRace.rawDate) || '-'))])])]) : _vm._e(), _vm._v(" "), (_vm.selectedRace) ? _c('div', {
    staticClass: "ado-toolbar ado-result-toolbar"
  }, [_c('label', {
    staticClass: "ado-field"
  }, [_c('span', {
    staticClass: "ado-label"
  }, [_vm._v("Runner Filter")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resultSearch),
      expression: "resultSearch"
    }],
    staticClass: "ado-input",
    attrs: {
      "type": "text",
      "placeholder": "runner id"
    },
    domProps: {
      "value": (_vm.resultSearch)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loadRaceResults(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.resultSearch = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "ado-primary-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadRaceResults(true)
      }
    }
  }, [_vm._v("Search Results")]), _vm._v(" "), _c('button', {
    staticClass: "ado-ghost-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearResultFilter
    }
  }, [_vm._v("Clear")])]) : _vm._e(), _vm._v(" "), (_vm.resultLoading && _vm.raceResults.length === 0) ? _c('div', {
    staticClass: "ado-skeleton-list"
  }, _vm._l((4), function(idx) {
    return _c('div', {
      key: idx,
      staticClass: "ado-skeleton-row"
    }, [_c('span', {
      staticClass: "sk-shimmer ado-sk-title"
    }), _vm._v(" "), _c('span', {
      staticClass: "sk-shimmer ado-sk-line"
    }), _vm._v(" "), _c('span', {
      staticClass: "sk-shimmer ado-sk-pill"
    })])
  }), 0) : _c('div', {
    staticClass: "ado-table-wrap"
  }, [_c('table', {
    staticClass: "ado-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_vm._l((_vm.raceResults), function(result) {
    return _c('tr', {
      key: result.id,
      staticClass: "ado-result-row"
    }, [_c('td', {
      staticClass: "ado-td"
    }, [_c('button', {
      staticClass: "ado-link-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openResultDialog(result)
        }
      }
    }, [_vm._v(_vm._s(result.runner && result.runner.id) + " - " + _vm._s(result.runner && result.runner.firstName))])]), _vm._v(" "), _c('td', {
      staticClass: "ado-td ado-rank-cell"
    }, [_vm._v(_vm._s(result.runnerPlace || '-'))]), _vm._v(" "), _c('td', {
      staticClass: "ado-td"
    }, [_vm._v(_vm._s(result.distanceLabel || result.distance))]), _vm._v(" "), _c('td', {
      staticClass: "ado-td ado-muted"
    }, [_vm._v(_vm._s(_vm.formatDate(result.rawCreatedDate)))]), _vm._v(" "), _c('td', {
      staticClass: "ado-td"
    }, [_vm._l((_vm.medalsForRunner(result.runner && result.runner.id)), function(entry) {
      return _c('button', {
        key: ((result.runner && result.runner.id) + "-" + (entry.medal && entry.medal.id)),
        staticClass: "ado-medal-chip ado-medal-chip-button",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.openBulkMedalDialog(result.runner && result.runner.id, entry.medal, 1)
          }
        }
      }, [_vm._v("\n                  " + _vm._s(entry.medal && entry.medal.badge) + "\n                ")])
    }), _vm._v(" "), _c('button', {
      staticClass: "ado-mini-action",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openBulkMedalDialog(result.runner && result.runner.id)
        }
      }
    }, [_vm._v("Edit")])], 2)])
  }), _vm._v(" "), (_vm.raceResults.length === 0) ? _c('tr', [_c('td', {
    staticClass: "ado-empty",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.selectedRace ? 'No race results loaded.' : 'Select a race first.'))])]) : _vm._e()], 2)]), _vm._v(" "), (_vm.resultPageModel && _vm.resultPageModel.last === false) ? _c('button', {
    staticClass: "ado-ghost-btn ado-load-more",
    attrs: {
      "type": "button",
      "disabled": _vm.resultLoading
    },
    on: {
      "click": _vm.loadNextResultPage
    }
  }, [_vm._v("\n          Load page " + _vm._s(_vm.resultPage + 2) + " of " + _vm._s(_vm.resultPageModel.totalPages) + "\n        ")]) : _vm._e()])])]), _vm._v(" "), _c('modal', {
    staticClass: "ado-modal",
    attrs: {
      "name": "ado-admin-tools-dialog",
      "adaptive": true,
      "scrollable": true,
      "height": "auto",
      "width": "94%",
      "maxWidth": 980
    },
    on: {
      "closed": _vm.handleAdminToolsClosed
    }
  }, [_c('div', {
    staticClass: "ado-dialog ado-tools-dialog"
  }, [_c('div', {
    staticClass: "ado-dialog-header"
  }, [_c('span', {
    staticClass: "ado-icon-pill"
  }, [_c('svg', {
    staticClass: "ado-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 15.5A3.5 3.5 0 1 0 12 8a3.5 3.5 0 0 0 0 7.5Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.6V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1-1.6 1.7 1.7 0 0 0-1.9.3l-.1.1A2 2 0 1 1 4.2 17l.1-.1a1.7 1.7 0 0 0 .3-1.9 1.7 1.7 0 0 0-1.6-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.6-1 1.7 1.7 0 0 0-.3-1.9L4.2 7A2 2 0 1 1 7 4.2l.1.1a1.7 1.7 0 0 0 1.9.3h.1A1.7 1.7 0 0 0 10 3V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.6 1.7 1.7 0 0 0 1.9-.3l.1-.1A2 2 0 1 1 19.8 7l-.1.1a1.7 1.7 0 0 0-.3 1.9v.1A1.7 1.7 0 0 0 21 10h.1a2 2 0 1 1 0 4H21a1.7 1.7 0 0 0-1.6 1Z"
    }
  })])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "ado-dialog-title"
  }, [_vm._v("Admin Tools")]), _vm._v(" "), _c('p', {
    staticClass: "ado-dialog-sub"
  }, [_vm._v("Use runner maintenance and recording utilities without leaving result corrections.")])]), _vm._v(" "), _c('button', {
    staticClass: "ado-close-btn",
    attrs: {
      "type": "button",
      "title": "Close"
    },
    on: {
      "click": _vm.closeAdminTools
    }
  }, [_c('svg', {
    staticClass: "ado-btn-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18 6 6 18"
    }
  }), _c('path', {
    attrs: {
      "d": "m6 6 12 12"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ado-dialog-body ado-tools-grid"
  }, [_c('section', {
    staticClass: "ado-tool-panel"
  }, [_c('div', {
    staticClass: "ado-card-header ado-card-header-spread"
  }, [_c('div', {
    staticClass: "ado-header-left"
  }, [_c('span', {
    staticClass: "ado-icon-pill"
  }, [_c('svg', {
    staticClass: "ado-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 21a8 8 0 0 0-16 0"
    }
  }), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "7",
      "r": "4"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "ado-card-title"
  }, [_vm._v("Runner Tools")]), _vm._v(" "), _c('p', {
    staticClass: "ado-card-sub"
  }, [_vm._v("Search, inspect analytics, reset distance, and manage promo codes.")])])]), _vm._v(" "), _c('button', {
    staticClass: "ado-ghost-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openBulkPromoDialog
    }
  }, [_vm._v("Bulk Promo")])]), _vm._v(" "), _c('div', {
    staticClass: "ado-toolbar ado-toolbar-stack"
  }, [_c('label', {
    staticClass: "ado-field"
  }, [_c('span', {
    staticClass: "ado-label"
  }, [_vm._v("Runner Search")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.runnerSearch),
      expression: "runnerSearch"
    }],
    staticClass: "ado-input",
    attrs: {
      "type": "text",
      "placeholder": "runner id"
    },
    domProps: {
      "value": (_vm.runnerSearch)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchRunners.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.runnerSearch = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "ado-primary-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchRunners
    }
  }, [_vm._v("Search Runner")])]), _vm._v(" "), (_vm.runnerLoading) ? _c('div', {
    staticClass: "ado-skeleton-list"
  }, [_c('div', {
    staticClass: "ado-skeleton-row"
  }, [_c('span', {
    staticClass: "sk-shimmer ado-sk-title"
  }), _vm._v(" "), _c('span', {
    staticClass: "sk-shimmer ado-sk-line"
  })])]) : _c('div', [_vm._l((_vm.runners), function(runner) {
    return _c('div', {
      key: runner.id,
      staticClass: "ado-runner-row"
    }, [_c('button', {
      staticClass: "ado-runner-select",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openRunnerActions(runner.id)
        }
      }
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(runner.id) + " - " + _vm._s(runner.firstName))]), _vm._v(" "), _c('small', [_vm._v("Open maintenance actions")])]), _vm._v(" "), _c('svg', {
      staticClass: "ado-btn-icon",
      attrs: {
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "d": "m9 18 6-6-6-6"
      }
    })])])])
  }), _vm._v(" "), (_vm.runners.length === 0) ? _c('div', {
    staticClass: "ado-empty-state"
  }, [_vm._v("Search a runner id to open analytics and promo-code tools.")]) : _vm._e()], 2)]), _vm._v(" "), _c('section', {
    staticClass: "ado-tool-panel"
  }, [_c('div', {
    staticClass: "ado-card-header ado-card-header-compact"
  }, [_c('div', {
    staticClass: "ado-header-left"
  }, [_c('span', {
    staticClass: "ado-icon-pill"
  }, [_c('svg', {
    staticClass: "ado-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"
    }
  }), _c('path', {
    attrs: {
      "d": "M7 9l5-5 5 5"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 4v12"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "ado-card-title"
  }, [_vm._v("Recording Uploader")]), _vm._v(" "), _c('p', {
    staticClass: "ado-card-sub"
  }, [_vm._v("Upload MP3 files and keep a local URL history.")])])])]), _vm._v(" "), _c('label', {
    staticClass: "ado-file-zone"
  }, [_c('input', {
    ref: "mp3Input",
    staticClass: "ado-file-input",
    attrs: {
      "type": "file",
      "accept": ".mp3,audio/mpeg",
      "multiple": ""
    },
    on: {
      "change": _vm.handleFiles
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ado-file-zone-title"
  }, [_vm._v("Select MP3 files")]), _vm._v(" "), _c('span', {
    staticClass: "ado-file-zone-sub"
  }, [_vm._v(_vm._s(_vm.uploadFiles.length ? _vm.uploadFiles.length + ' file(s) ready' : 'Drag-style picker for recordings'))])]), _vm._v(" "), _vm._l((_vm.uploadFiles), function(file) {
    return _c('div', {
      key: file._key,
      staticClass: "ado-upload-row"
    }, [_c('span', [_vm._v(_vm._s(file.name) + _vm._s(file.extension) + " · " + _vm._s(file.sizeLabel))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(file.progress || 0) + "%")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "ado-actions"
  }, [_c('button', {
    staticClass: "ado-primary-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.uploadLoading || _vm.uploadFiles.length === 0
    },
    on: {
      "click": _vm.uploadAllFiles
    }
  }, [_vm._v("Upload")]), _vm._v(" "), _c('button', {
    staticClass: "ado-ghost-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearUploadHistory
    }
  }, [_vm._v("Clear History")])]), _vm._v(" "), _c('div', {
    staticClass: "ado-history"
  }, _vm._l((_vm.uploadHistory), function(entry) {
    return _c('div', {
      key: entry.url,
      staticClass: "ado-promo-row"
    }, [_c('span', [_vm._v(_vm._s(entry.name))]), _vm._v(" "), _c('button', {
      staticClass: "ado-ghost-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.copyUrl(entry.url)
        }
      }
    }, [_vm._v("Copy URL")])])
  }), 0)], 2)])])]), _vm._v(" "), _c('modal', {
    staticClass: "ado-modal",
    attrs: {
      "name": "ado-runner-actions-dialog",
      "adaptive": true,
      "scrollable": true,
      "height": "auto",
      "width": "90%",
      "maxWidth": 760
    }
  }, [_c('div', {
    staticClass: "ado-dialog"
  }, [_c('div', {
    staticClass: "ado-dialog-header"
  }, [_c('span', {
    staticClass: "ado-icon-pill"
  }, [_c('svg', {
    staticClass: "ado-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 21a8 8 0 0 0-16 0"
    }
  }), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "7",
      "r": "4"
    }
  })])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "ado-dialog-title"
  }, [_vm._v("Runner Actions")]), _vm._v(" "), _c('p', {
    staticClass: "ado-dialog-sub"
  }, [_vm._v(_vm._s(_vm.selectedRunner ? _vm.selectedRunner.id + ' - ' + _vm.selectedRunner.firstName : 'Loading runner context'))])]), _vm._v(" "), _c('button', {
    staticClass: "ado-close-btn",
    attrs: {
      "type": "button",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('ado-runner-actions-dialog')
      }
    }
  }, [_c('svg', {
    staticClass: "ado-btn-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18 6 6 18"
    }
  }), _c('path', {
    attrs: {
      "d": "m6 6 12 12"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ado-dialog-body"
  }, [(_vm.runnerLoading && !_vm.selectedRunner) ? _c('div', {
    staticClass: "ado-skeleton-list"
  }, [_c('div', {
    staticClass: "ado-skeleton-row"
  }, [_c('span', {
    staticClass: "sk-shimmer ado-sk-title"
  }), _vm._v(" "), _c('span', {
    staticClass: "sk-shimmer ado-sk-line"
  }), _vm._v(" "), _c('span', {
    staticClass: "sk-shimmer ado-sk-pill"
  })])]) : (_vm.selectedRunner) ? _c('div', {
    staticClass: "ado-runner-actions-panel"
  }, [_c('div', {
    staticClass: "ado-detail-title"
  }, [_vm._v(_vm._s(_vm.selectedRunner.id) + " - " + _vm._s(_vm.selectedRunner.firstName))]), _vm._v(" "), (_vm.runnerAnalytics) ? _c('div', {
    staticClass: "ado-kpi-grid"
  }, [_c('div', {
    staticClass: "ado-kpi"
  }, [_c('span', {
    staticClass: "ado-kpi-label"
  }, [_vm._v("Total completed")]), _c('strong', {
    staticClass: "ado-kpi-value"
  }, [_vm._v(_vm._s(_vm.runnerAnalytics.totalCompletedRuns))])]), _vm._v(" "), _c('div', {
    staticClass: "ado-kpi"
  }, [_c('span', {
    staticClass: "ado-kpi-label"
  }, [_vm._v("Total distance")]), _c('strong', {
    staticClass: "ado-kpi-value"
  }, [_vm._v(_vm._s(_vm.runnerAnalytics.totalDistancePerfomed))])]), _vm._v(" "), _c('div', {
    staticClass: "ado-kpi"
  }, [_c('span', {
    staticClass: "ado-kpi-label"
  }, [_vm._v("Sum distance")]), _c('strong', {
    staticClass: "ado-kpi-value"
  }, [_vm._v(_vm._s(_vm.runnerAnalytics.sumTotalDistancePerfomed))])]), _vm._v(" "), _c('div', {
    staticClass: "ado-kpi"
  }, [_c('span', {
    staticClass: "ado-kpi-label"
  }, [_vm._v("Last 30 days")]), _c('strong', {
    staticClass: "ado-kpi-value"
  }, [_vm._v(_vm._s(_vm.runnerAnalytics.totalRacesLast30days))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ado-runner-action-strip"
  }, [_c('button', {
    staticClass: "ado-ghost-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetRunnerDistance
    }
  }, [_c('svg', {
    staticClass: "ado-btn-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 12a9 9 0 1 0 3-6.7"
    }
  }), _c('path', {
    attrs: {
      "d": "M3 4v6h6"
    }
  })]), _vm._v("\n              Reset Distance\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "ado-ghost-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetRunnerPassword
    }
  }, [_c('svg', {
    staticClass: "ado-btn-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "11",
      "width": "18",
      "height": "10",
      "rx": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M7 11V7a5 5 0 0 1 10 0v4"
    }
  })]), _vm._v("\n              Reset Password\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "ado-promo-manager"
  }, [_c('div', {
    staticClass: "ado-section-heading"
  }, [_c('strong', [_vm._v("Promo codes")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.selectedRunner.memberShip && _vm.selectedRunner.memberShip.promoCodeList ? _vm.selectedRunner.memberShip.promoCodeList.length : 0) + " active")])]), _vm._v(" "), _c('div', {
    staticClass: "ado-toolbar ado-toolbar-stack"
  }, [_c('label', {
    staticClass: "ado-field"
  }, [_c('span', {
    staticClass: "ado-label"
  }, [_vm._v("Promo code id or code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.runnerPromoCode),
      expression: "runnerPromoCode"
    }],
    staticClass: "ado-input",
    attrs: {
      "type": "text",
      "placeholder": "promo id or code"
    },
    domProps: {
      "value": (_vm.runnerPromoCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.runnerPromoCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "ado-primary-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addPromoCodeToRunner
    }
  }, [_vm._v("Add Promo Code")])]), _vm._v(" "), (_vm.selectedRunner.memberShip && _vm.selectedRunner.memberShip.promoCodeList && _vm.selectedRunner.memberShip.promoCodeList.length) ? _c('div', {
    staticClass: "ado-promo-list"
  }, _vm._l((_vm.selectedRunner.memberShip.promoCodeList), function(promo) {
    return _c('div', {
      key: promo.id,
      staticClass: "ado-promo-row"
    }, [_c('span', [_vm._v(_vm._s(promo.id) + " - " + _vm._s(promo.code))]), _vm._v(" "), _c('button', {
      staticClass: "ado-icon-btn",
      attrs: {
        "type": "button",
        "title": "Remove promo code"
      },
      on: {
        "click": function($event) {
          return _vm.removePromoCodeFromRunner(promo)
        }
      }
    }, [_c('svg', {
      staticClass: "ado-btn-icon",
      attrs: {
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "d": "M18 6 6 18"
      }
    }), _c('path', {
      attrs: {
        "d": "m6 6 12 12"
      }
    })])])])
  }), 0) : _c('div', {
    staticClass: "ado-empty-state"
  }, [_vm._v("No promo codes assigned to this runner.")])])]) : _c('div', {
    staticClass: "ado-empty-state"
  }, [_vm._v("Select a runner from Admin Tools to load actions.")])]), _vm._v(" "), _c('div', {
    staticClass: "ado-dialog-footer"
  }, [_c('button', {
    staticClass: "ado-ghost-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backToAdminTools
    }
  }, [_c('svg', {
    staticClass: "ado-btn-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "m15 18-6-6 6-6"
    }
  })]), _vm._v("\n          Back to Admin Tools\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "ado-ghost-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('ado-runner-actions-dialog')
      }
    }
  }, [_vm._v("Close")])])])]), _vm._v(" "), _c('modal', {
    staticClass: "ado-modal",
    attrs: {
      "name": "ado-result-dialog",
      "adaptive": true,
      "scrollable": true,
      "height": "auto",
      "width": "90%",
      "maxWidth": 620
    }
  }, [_c('div', {
    staticClass: "ado-dialog"
  }, [_c('div', {
    staticClass: "ado-dialog-header"
  }, [_c('span', {
    staticClass: "ado-icon-pill"
  }, [_c('svg', {
    staticClass: "ado-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 5v14"
    }
  }), _c('path', {
    attrs: {
      "d": "M5 12h14"
    }
  })])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "ado-dialog-title"
  }, [_vm._v(_vm._s(_vm.resultForm.id ? 'Edit Result' : 'Add Result'))]), _vm._v(" "), _c('p', {
    staticClass: "ado-dialog-sub"
  }, [_vm._v("Save a runner result correction for the selected race.")])]), _vm._v(" "), _c('button', {
    staticClass: "ado-close-btn",
    attrs: {
      "type": "button",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('ado-result-dialog')
      }
    }
  }, [_c('svg', {
    staticClass: "ado-btn-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18 6 6 18"
    }
  }), _c('path', {
    attrs: {
      "d": "m6 6 12 12"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ado-dialog-body"
  }, [_c('label', {
    staticClass: "ado-field"
  }, [_c('span', {
    staticClass: "ado-label"
  }, [_vm._v("Race ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resultForm.raceId),
      expression: "resultForm.raceId"
    }],
    staticClass: "ado-input",
    attrs: {
      "type": "number",
      "list": "ado-race-id-options"
    },
    domProps: {
      "value": (_vm.resultForm.raceId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resultForm, "raceId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('datalist', {
    attrs: {
      "id": "ado-race-id-options"
    }
  }, _vm._l((_vm.races), function(race) {
    return _c('option', {
      key: race.id,
      domProps: {
        "value": race.id
      }
    }, [_vm._v(_vm._s(race.id) + " - " + _vm._s(race.name))])
  }), 0)]), _vm._v(" "), _c('label', {
    staticClass: "ado-field"
  }, [_c('span', {
    staticClass: "ado-label"
  }, [_vm._v("Runner ID")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resultForm.runnerId),
      expression: "resultForm.runnerId"
    }],
    staticClass: "ado-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.resultForm.runnerId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resultForm, "runnerId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "ado-field"
  }, [_c('span', {
    staticClass: "ado-label"
  }, [_vm._v("Distance")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resultForm.distance),
      expression: "resultForm.distance"
    }],
    staticClass: "ado-input",
    attrs: {
      "type": "number",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.resultForm.distance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resultForm, "distance", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ado-time-grid"
  }, [_c('label', {
    staticClass: "ado-field"
  }, [_c('span', {
    staticClass: "ado-label"
  }, [_vm._v("Finish date")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resultForm.finishDate),
      expression: "resultForm.finishDate"
    }],
    staticClass: "ado-input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.resultForm.finishDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resultForm, "finishDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "ado-field"
  }, [_c('span', {
    staticClass: "ado-label"
  }, [_vm._v("Finish time")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resultForm.finishTime),
      expression: "resultForm.finishTime"
    }],
    staticClass: "ado-input",
    attrs: {
      "type": "time",
      "step": "60"
    },
    domProps: {
      "value": (_vm.resultForm.finishTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resultForm, "finishTime", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ado-time-preview"
  }, [_c('span', [_vm._v("Local time")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.resultLocalPreview))]), _vm._v(" "), _c('small', [_vm._v("UTC saved value: " + _vm._s(_vm.resultUtcPreview))])]), _vm._v(" "), (_vm.dialogError) ? _c('p', {
    staticClass: "ado-error"
  }, [_vm._v(_vm._s(_vm.dialogError))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ado-dialog-footer"
  }, [(_vm.resultForm.id) ? _c('button', {
    staticClass: "ado-danger-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeRaceResult
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "ado-ghost-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('ado-result-dialog')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "ado-primary-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveRaceResult
    }
  }, [_vm._v("Save")])])])]), _vm._v(" "), _c('modal', {
    staticClass: "ado-modal",
    attrs: {
      "name": "ado-bulk-medal-dialog",
      "adaptive": true,
      "scrollable": true,
      "height": "auto",
      "width": "90%",
      "maxWidth": 620
    }
  }, [_c('div', {
    staticClass: "ado-dialog"
  }, [_c('div', {
    staticClass: "ado-dialog-header"
  }, [_c('span', {
    staticClass: "ado-icon-pill"
  }, [_c('svg', {
    staticClass: "ado-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 21h8"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 17v4"
    }
  }), _c('path', {
    attrs: {
      "d": "M7 4h10v5a5 5 0 0 1-10 0V4Z"
    }
  })])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "ado-dialog-title"
  }, [_vm._v("Bulk Medal")]), _vm._v(" "), _c('p', {
    staticClass: "ado-dialog-sub"
  }, [_vm._v("Add or remove one medal for runner IDs in this race.")])]), _vm._v(" "), _c('button', {
    staticClass: "ado-close-btn",
    attrs: {
      "type": "button",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('ado-bulk-medal-dialog')
      }
    }
  }, [_c('svg', {
    staticClass: "ado-btn-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18 6 6 18"
    }
  }), _c('path', {
    attrs: {
      "d": "m6 6 12 12"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ado-dialog-body"
  }, [_c('div', {
    staticClass: "ado-medal-picker"
  }, [_c('label', {
    staticClass: "ado-field"
  }, [_c('span', {
    staticClass: "ado-label"
  }, [_vm._v("Medal")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.bulkMedal.medalSearch),
      expression: "bulkMedal.medalSearch",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "ado-input",
    attrs: {
      "type": "text",
      "placeholder": "Search medal name or ID"
    },
    domProps: {
      "value": (_vm.bulkMedal.medalSearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bulkMedal, "medalSearch", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.selectedBulkMedal) ? _c('div', {
    staticClass: "ado-selected-medal"
  }, [_c('span', {
    staticClass: "ado-selected-medal-name"
  }, [_vm._v(_vm._s(_vm.medalLabel(_vm.selectedBulkMedal)))]), _vm._v(" "), _c('span', {
    staticClass: "ado-selected-medal-id"
  }, [_vm._v("#" + _vm._s(_vm.selectedBulkMedal.id))])]) : _vm._e(), _vm._v(" "), (_vm.medalOptionsLoading) ? _c('div', {
    staticClass: "ado-medal-grid"
  }, _vm._l((4), function(idx) {
    return _c('span', {
      key: idx,
      staticClass: "sk-shimmer ado-medal-option-skeleton"
    })
  }), 0) : (_vm.filteredBulkMedalOptions.length) ? _c('div', {
    staticClass: "ado-medal-grid"
  }, _vm._l((_vm.filteredBulkMedalOptions), function(medal) {
    return _c('button', {
      key: medal.id,
      staticClass: "ado-medal-option",
      class: {
        'ado-medal-option-selected': Number(_vm.bulkMedal.medalId) === Number(medal.id)
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectBulkMedal(medal)
        }
      }
    }, [_c('span', {
      staticClass: "ado-medal-option-name"
    }, [_vm._v(_vm._s(_vm.medalLabel(medal)))]), _vm._v(" "), _c('span', {
      staticClass: "ado-medal-option-id"
    }, [_vm._v("#" + _vm._s(medal.id))])])
  }), 0) : _c('div', {
    staticClass: "ado-empty-state"
  }, [_vm._v("No medals were returned for this race.")]), _vm._v(" "), (_vm.bulkMedalError) ? _c('p', {
    staticClass: "ado-error"
  }, [_vm._v(_vm._s(_vm.bulkMedalError))]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "ado-field"
  }, [_c('span', {
    staticClass: "ado-label"
  }, [_vm._v("Runner IDs")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bulkMedal.targetIds),
      expression: "bulkMedal.targetIds"
    }],
    staticClass: "ado-input ado-textarea",
    attrs: {
      "placeholder": "comma or space separated IDs"
    },
    domProps: {
      "value": (_vm.bulkMedal.targetIds)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bulkMedal, "targetIds", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "ado-field"
  }, [_c('span', {
    staticClass: "ado-label"
  }, [_vm._v("Action")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.bulkMedal.action),
      expression: "bulkMedal.action",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "ado-input",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.bulkMedal, "action", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Add")]), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Remove")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ado-dialog-footer"
  }, [_c('button', {
    staticClass: "ado-ghost-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('ado-bulk-medal-dialog')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "ado-primary-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.performMedalBulk
    }
  }, [_vm._v("Run Action")])])])]), _vm._v(" "), _c('modal', {
    staticClass: "ado-modal",
    attrs: {
      "name": "ado-bulk-promo-dialog",
      "adaptive": true,
      "scrollable": true,
      "height": "auto",
      "width": "90%",
      "maxWidth": 620
    }
  }, [_c('div', {
    staticClass: "ado-dialog"
  }, [_c('div', {
    staticClass: "ado-dialog-header"
  }, [_c('span', {
    staticClass: "ado-icon-pill"
  }, [_c('svg', {
    staticClass: "ado-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7"
    }
  }), _c('path', {
    attrs: {
      "d": "M2 7h20v5H2z"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 22V7"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 7h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7Z"
    }
  })])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "ado-dialog-title"
  }, [_vm._v("Bulk Promo Code")]), _vm._v(" "), _c('p', {
    staticClass: "ado-dialog-sub"
  }, [_vm._v("Add or remove one promo code for multiple runner IDs.")])]), _vm._v(" "), _c('button', {
    staticClass: "ado-close-btn",
    attrs: {
      "type": "button",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('ado-bulk-promo-dialog')
      }
    }
  }, [_c('svg', {
    staticClass: "ado-btn-icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18 6 6 18"
    }
  }), _c('path', {
    attrs: {
      "d": "m6 6 12 12"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ado-dialog-body"
  }, [_c('label', {
    staticClass: "ado-field"
  }, [_c('span', {
    staticClass: "ado-label"
  }, [_vm._v("Promo code id or code")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bulkPromo.promoCode),
      expression: "bulkPromo.promoCode"
    }],
    staticClass: "ado-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.bulkPromo.promoCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bulkPromo, "promoCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "ado-field"
  }, [_c('span', {
    staticClass: "ado-label"
  }, [_vm._v("Runner IDs")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bulkPromo.targetIds),
      expression: "bulkPromo.targetIds"
    }],
    staticClass: "ado-input ado-textarea",
    attrs: {
      "placeholder": "comma or space separated IDs"
    },
    domProps: {
      "value": (_vm.bulkPromo.targetIds)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bulkPromo, "targetIds", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "ado-field"
  }, [_c('span', {
    staticClass: "ado-label"
  }, [_vm._v("Action")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.bulkPromo.action),
      expression: "bulkPromo.action",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "ado-input",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.bulkPromo, "action", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Add")]), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Remove")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ado-dialog-footer"
  }, [_c('button', {
    staticClass: "ado-ghost-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('ado-bulk-promo-dialog')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "ado-primary-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.performPromoBulk
    }
  }, [_vm._v("Run Action")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "pg-title"
  }, [_vm._v("Admin Data Operations")]), _vm._v(" "), _c('p', {
    staticClass: "pg-title-sub"
  }, [_vm._v("Find a race, correct results, inspect runners, and upload recordings from one controlled admin workspace.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "ado-card-title"
  }, [_vm._v("Race Sessions")]), _vm._v(" "), _c('p', {
    staticClass: "ado-card-sub"
  }, [_vm._v("Find sessions by date or search and open result correction tools.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "ado-th"
  }, [_vm._v("Runner")]), _vm._v(" "), _c('th', {
    staticClass: "ado-th"
  }, [_vm._v("Place")]), _vm._v(" "), _c('th', {
    staticClass: "ado-th"
  }, [_vm._v("Distance")]), _vm._v(" "), _c('th', {
    staticClass: "ado-th"
  }, [_vm._v("Created")]), _vm._v(" "), _c('th', {
    staticClass: "ado-th"
  }, [_vm._v("Medals")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f57290e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/AdminDataOperations.vue
// module id = 1764
// module chunks = 2